<rt-group
  *ngIf="candidates && candidates.length > 0"
  [class.stacked]="true"
  [class.horizontal]="true"
  class="group"
  margin-left-small-xxx
>
  <rt-avatar
    *ngFor="let candidate of candidates | slice: 0:3; trackBy: trackByCandidate"
    [type]="candidate.hasAvatar ? 'image' : 'initials'"
    [imageSrc]="candidate.photoThumbUrl"
    [initials]="candidate.initials"
    [context]="'candidate'"
    size="small"
    class="background-automated-actions-assistant"
  >
  </rt-avatar>
  <div *ngIf="candidates.length > 3" class="more-indicator">
    <rt-icon name="more-horiz" [color]="IconColor.Default"></rt-icon>
  </div>
</rt-group>
